"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var services_1 = require("../../../../../shared/services");
var initialState = function () {
    return {
        formId: '',
        formKey: '',
        storeCode: null,
        authToken: services_1.appSessionStorage.getItem('auth_token', null),
        isLoggedIn: null !== services_1.appSessionStorage.getItem('checkout-customer', {}) ? (services_1.appSessionStorage.getItem('checkout-customer', {})).hasOwnProperty('entity_id') : false,
        customer: services_1.appSessionStorage.getItem('checkout-customer', false),
        customerEmail: services_1.appSessionStorage.getItem('checkout-customer-email', null),
        quote: services_1.appLocalStorage.getItem('checkout-quote', null),
        quoteId: services_1.appLocalStorage.getItem('checkout-quote-id', null),
        quoteMask: services_1.appLocalStorage.getItem('checkout-quote-mask', null),
        quoteItems: services_1.appSessionStorage.getItem('checkout-quote-items', null),
        lastAddedItem: {},
        quoteItemCount: services_1.appLocalStorage.getItem('checkout-quote-item-count', 0),
        shippingCountries: services_1.appSessionStorage.getItem('checkout-shipping-counties', []),
    };
};
var state = initialState();
var getters = {
    isLoggedIn: function (state) { return state.isLoggedIn; },
    getQuoteIdentifier: function (state) { return "" + (state.isLoggedIn ? state.quoteId : state.quoteMask); },
    getCustomer: function (state) {
        if ((state.customer || {}).hasOwnProperty('email')) {
            state.customerEmail = state.customer.email;
        }
        return state.customer;
    },
    defaultShippingAddress: function (state) {
        return (state.customer || {}).hasOwnProperty('default_shipping_address')
            ? state.customer['default_shipping_address'] : null;
    },
    defaultBillingAddress: function (state) {
        return (state.customer || {}).hasOwnProperty('default_billing_address')
            ? state.customer['default_billing_address'] : null;
    },
    customerAddresses: function (state) {
        return (state.customer || {}).hasOwnProperty('addresses')
            ? state.customer['addresses'] : [];
    },
    // Api Url Section.
    getApiPath: function (state) {
        return "rest/" + state.storeCode + "/V1/" + (state.isLoggedIn ? 'carts/mine' : 'guest-carts');
    },
    getApiPathWithQuoteId: function (state) {
        return "rest/" + state.storeCode + "/V1/" + (state.isLoggedIn ? 'carts/mine' : 'guest-carts/' + state.quoteId);
    },
    getApiPathWithQuoteMask: function (state) {
        return "rest/" + state.storeCode + "/V1/" + (state.isLoggedIn ? 'carts/mine' : 'guest-carts/' + getters.getQuoteIdentifier(state));
    },
    getBuckarooApiPathWithQuoteMask: function (state) {
        return "rest/" + state.storeCode + "/V1/" + (state.isLoggedIn ? 'buckaroo' : 'guest-buckaroo/' + getters.getQuoteIdentifier(state));
    },
    getShippingCountries: function (state) {
        if (state.shippingCountries.length > 0) {
            return state.shippingCountries;
        }
        return [{
                'id': 'NL',
                'full_name_locale': 'Nederland',
            }];
    }
};
var mutations = {
    SET_AUTH_TOKEN: function (state, authToken) {
        state.authToken = authToken;
    },
    SET_FORM_ID: function (state, formId) {
        state.formId = formId;
    },
    SET_FORM_KEY: function (state, formKey) {
        state.formKey = formKey;
    },
    SET_STORE_CODE: function (state, storeCode) {
        state.storeCode = storeCode;
    },
    SET_CUSTOMER: function (state, customer) {
        state.customer = customer;
        state.isLoggedIn = (customer || {}).hasOwnProperty('entity_id');
        if (state.customer.hasOwnProperty('entity_id')) {
            services_1.appSessionStorage.setItem('checkout-customer', customer || {});
        }
    },
    SET_CUSTOMER_EMAIL: function (state, customerEmail) {
        if (!(state.customer || {}).hasOwnProperty('entity_id')) {
            state.customer = {};
            state.customer.email = customerEmail;
            state.customerEmail = state.customer.email;
            services_1.appSessionStorage.setItem('checkout-customer-email', state.customerEmail || '');
            if (!state.customer.hasOwnProperty('entity_id')) {
                services_1.appSessionStorage.setItem('checkout-customer', state.customer || {});
            }
        }
    },
    SET_QUOTE: function (state, quote) {
        state.quote = quote;
        state.quoteId = quote['id'];
        state.quoteItems = quote['items'];
        state.quoteItemCount = quote['items_count'];
        services_1.appLocalStorage.setItem('checkout-quote', quote);
        services_1.appLocalStorage.setItem('checkout-quote-id', quote['id']);
        services_1.appSessionStorage.setItem('checkout-quote-items', quote['items']);
        services_1.appLocalStorage.setItem('checkout-quote-item-count', quote['items_count']);
    },
    SET_QUOTE_MASK: function (state, quoteMask) {
        state.quoteMask = quoteMask;
        services_1.appLocalStorage.setItem('checkout-quote-mask', quoteMask);
    },
    SET_QUOTE_ITEMS: function (state, quoteItems) {
        state.quoteItems = quoteItems;
        services_1.appSessionStorage.setItem('checkout-quote-items', quoteItems);
    },
    SET_LAST_ADDED_ITEM: function (state, quoteItem) {
        state.lastAddedItem = JSON.parse(quoteItem);
    },
    SET_QUOTE_ITEM_COUNT: function (state, count) {
        state.quoteItemCount = count;
        services_1.appLocalStorage.setItem('checkout-quote-item-count', count);
    },
    SET_SHIPPING_COUNTRIES: function (state, payload) {
        state.shippingCountries = payload;
        services_1.appSessionStorage.setItem('checkout-shipping-counties', payload);
    }
};
var actions = {
    initialize: function (_a) {
        var state = _a.state, commit = _a.commit, dispatch = _a.dispatch;
        return __awaiter(this, void 0, void 0, function () {
            var _urlHash, arr, i, i, i, i, data, e_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (null === state.storeCode) {
                            commit('SET_STORE_CODE', window['Config']['active_store_code'] || 'default');
                        }
                        _urlHash = null;
                        if (window.location.hash.length) {
                            _urlHash = window.location.hash;
                            history.replaceState("", document.title, window.location.href.replace(window.location.hash, ''));
                        }
                        if (!(_urlHash === '#clear')) return [3 /*break*/, 2];
                        arr = [];
                        // Iterate over localStorage and insert the keys that meet the condition into arr
                        for (i = 0; i < localStorage.length; i++) {
                            if (localStorage.key(i).startsWith('checkout-')) {
                                arr.push(localStorage.key(i));
                            }
                        }
                        // Iterate over arr and remove the items by key
                        for (i = 0; i < arr.length; i++) {
                            localStorage.removeItem(arr[i]);
                        }
                        arr = []; // Array to hold the keys
                        // Iterate over localStorage and insert the keys that meet the condition into arr
                        for (i = 0; i < sessionStorage.length; i++) {
                            if (sessionStorage.key(i).startsWith('checkout-')) {
                                arr.push(sessionStorage.key(i));
                            }
                        }
                        // Iterate over arr and remove the items by key
                        for (i = 0; i < arr.length; i++) {
                            sessionStorage.removeItem(arr[i]);
                        }
                        return [4 /*yield*/, dispatch('CheckoutCart/createQuote', null, { root: true })];
                    case 1:
                        _b.sent();
                        _b.label = 2;
                    case 2:
                        if (_urlHash === '#login') {
                            services_1.appSessionStorage.removeItem('checkout-billing-address');
                            services_1.appSessionStorage.removeItem('checkout-shipping-address');
                            commit('CheckoutCart/SET_BILLING_ADDRESS', {});
                            commit('CheckoutCart/SET_SHIPPING_ADDRESS', {});
                        }
                        if (!(state.authToken !== null && !state.customer.hasOwnProperty('entity_id'))) return [3 /*break*/, 9];
                        _b.label = 3;
                    case 3:
                        _b.trys.push([3, 8, , 9]);
                        return [4 /*yield*/, this.$solarClient.get('/api/customer/getCurrent')];
                    case 4:
                        data = (_b.sent()).data;
                        if (!data) return [3 /*break*/, 7];
                        return [4 /*yield*/, commit('SET_CUSTOMER', data)];
                    case 5:
                        _b.sent();
                        return [4 /*yield*/, dispatch('CheckoutCart/mergeQuote', null, { root: true })];
                    case 6:
                        _b.sent();
                        _b.label = 7;
                    case 7: return [3 /*break*/, 9];
                    case 8:
                        e_1 = _b.sent();
                        return [3 /*break*/, 9];
                    case 9:
                        if (!(null === state.quoteId && state.quoteMask)) return [3 /*break*/, 11];
                        return [4 /*yield*/, dispatch('CheckoutCart/fetchQuote', null, { root: true })];
                    case 10:
                        _b.sent();
                        _b.label = 11;
                    case 11: return [2 /*return*/];
                }
            });
        });
    },
    getActiveQuote: function (_a) {
        var commit = _a.commit, dispatch = _a.dispatch;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(null === state.quoteMask || (!state.isLoggedIn && state.quoteId === state.quoteMask))) return [3 /*break*/, 2];
                        return [4 /*yield*/, dispatch('CheckoutCart/createQuote', null, { root: true })];
                    case 1:
                        _b.sent();
                        _b.label = 2;
                    case 2:
                        if (!(null === state.quoteId)) return [3 /*break*/, 4];
                        return [4 /*yield*/, dispatch('CheckoutCart/fetchQuote', null, { root: true })];
                    case 3:
                        _b.sent();
                        _b.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    },
    createNewQuote: function (_a) {
        var commit = _a.commit, dispatch = _a.dispatch;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, dispatch('CheckoutCart/createQuote', null, { root: true })];
                    case 1:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    },
    setFormId: function (_a, formId) {
        var commit = _a.commit;
        commit('SET_FORM_ID', formId);
    },
    setFormKey: function (_a, formKey) {
        var commit = _a.commit;
        commit('SET_FORM_KEY', formKey);
    },
    collectShippingCountries: function (_a) {
        var commit = _a.commit, rootState = _a.rootState;
        return __awaiter(this, void 0, void 0, function () {
            var data, e_2;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.$mageClient.get("/rest/" + rootState['CheckoutGlobal']['storeCode'] + "/V1/directory/countries")];
                    case 1:
                        data = (_b.sent()).data;
                        if (data) {
                            commit('SET_SHIPPING_COUNTRIES', data);
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        e_2 = _b.sent();
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    }
};
var CheckoutGlobal = {
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
};
exports.default = CheckoutGlobal;
